import { useEffect, useState } from "react";
import Pdf from "../../../Components/Deliveries/pdf/pdf";
import axiosInstance from "../../../Configuration/axiosInstance";
import DeliveriesTable from "../DeliveriesTable/DeliveriesTable";
import stylez from "../Delivery.module.css";
import { useNavigate } from "react-router-dom";
import SearchStrip from "../../../Components/Deliveries/SearchStrip/SearchStrip";

const CompletedDeliveries = () => {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [count, setCount] = useState();
  const [deliveries, setDeliveries] = useState();
  const [loading, setLoading] = useState(true);
  const [stateChanged, setStateChanged] = useState(false);
  const [printSelected, setPrintSelected] = useState([]);
  const [print, setPrint] = useState([]);
  const [show, setShow] = useState(false);
  const [prods, setProds] = useState([]);
  const [order, setOrder] = useState();
  const [searchCriteria, setSearchCriteria] = useState({
    runId: "",
    fromDate: "",
    toDate: "",
  });
  const [clearFilters, setClearFilters] = useState(false);
  const [products, setProducts] = useState([]);
  const [prodID, setProdID] = useState("");
  const [result, setResult] = useState(0);

  const status = ["Delivered"];

  const navigate = useNavigate();
  const updateDeliveries = (i) => {
    navigate("/updateDeliveries", { state: i });
  };

  useEffect(() => {
    setLoading(true);

    axiosInstance
      .get(
        `delivery?page=${page}&limit=${pageSize}&fromDate=${searchCriteria.fromDate}&toDate=${searchCriteria.toDate}&deliveryId=${searchCriteria.runId}&status=${status}`
      )
      .then((res) => {
        setDeliveries(res.data.data);
        axiosInstance
          .get(`products/allproducts`)
          .then((res) => setProducts(res.data.data));
        setCount(res.data.count);
        setLoading(false);
      });
  }, [stateChanged, page, pageSize]);
  const deleteDelivery = (i) => {
    axiosInstance.delete(`delivery/${i}`).then((data) => {
      setStateChanged((prevValue) => !prevValue);
    });
  };
  // Page indexing

  const handleNext = () => {
    setPage((preValue) => preValue + 1);
  };
  const handlePrevious = () => {
    setPage((preValue) => preValue - 1);
  };

  const handleChecked = (e, id) => {
    if (e.target.checked) {
      setPrintSelected((preValues) => [...preValues, e.target.value]);
    } else if (!e.target.checked) {
      setPrintSelected(printSelected.filter((i) => i !== id));
    }
    // Include the first selected item in the print selection
    const printSelection = [...printSelected];
    if (!printSelection.includes(id)) {
      printSelection.push(id);
    }
    setPrint(deliveries.filter((obj) => printSelection.includes(obj._id)));
  };

  const handleProductModal = (products, order) => {
    setProds(products);
    setOrder(order);
    setShow(true);
  };

  const calculateStocks = () => {
    console.log(deliveries);
    console.log(prodID);
    const prdi = deliveries.map((i) => {
      return i.order.map((o) =>
        o.products.filter((i) => i.product?._id === prodID.label)
      );
    });

    setResult(
      prdi
        .flatMap((i) => i.flatMap((j) => j.map((num) => num.quantity)))
        .reduce((acc, curr) => acc + curr, 0)
    );
  };
  const headings = [
    "Select",
    "Run Name",
    "Vehicle Rego",
    "Order Details",
    "Expected Delivery Date",
    "Assigned Drivers",
    "Status",
    "Actions",
  ];
  return (
    <div>
      <div className={stylez.heading}>
        <h2>Completed Deliveries</h2>

        <SearchStrip
          clearFilters={clearFilters}
          setClearFilters={setClearFilters}
          setStateChanged={setStateChanged}
          searchCriteria={searchCriteria}
          setSearchCriteria={setSearchCriteria}
          setPageSize={setPageSize}
          setPage={setPage}
          products={products}
          setProdID={setProdID}
          result={result}
          calculateStocks={calculateStocks}
          pageSize={pageSize}
        />
        <Pdf data={print} />
        {/* Implement a search Strip to search for the deliveries using date or RUN ID */}
      </div>
      <DeliveriesTable
        show={show}
        setShow={setShow}
        order={order}
        prods={prods}
        loading={loading}
        deliveries={deliveries}
        handleChecked={handleChecked}
        handleProductModal={handleProductModal}
        updateDeliveries={updateDeliveries}
        deleteDelivery={deleteDelivery}
        page={page}
        handleNext={handleNext}
        pageSize={pageSize}
        handlePrevious={handlePrevious}
        count={count}
        headings={headings}
      />
    </div>
  );
};
export default CompletedDeliveries;
